<style lang="scss" scoped>
  hr {
    padding-left: -30px
  }

  .modal-no-header-no-footer .modal-title {
    margin-bottom: 0px;
  }
</style>
<template>
  <BModal
    size="lg"
    id="modal-edit-account"
    ref="modal-edit-account"
    hide-header="hide-header"
    hide-footer="hide-footer"
    modal-class="modal-no-header-no-footer"
  >
    <template
      slot="default"
    >
      <button
        class="close"
        type="button"
        aria-label="Close"
        @click="$refs['modal-edit-account'].hide()"
      >
        <span
          aria-hidden="true"
        >
          ×
        </span>
      </button>

      <h4
        v-text="__(title)"
        class="modal-title align-items-center text-center"
      />

      <BillingAccount
        class="p-15px"
        :user="user"
        :cnpj="true"
      />
    </template>
  </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {
      form: {
        name: null,
        description: null,
      },
      modules: [],
      types: false,
      error: null,
      saving: false,
      title: 'Atualize sua conta',
    };
  },

  mounted () {
    Bus.$on('openModalEditAccount', (title) => {
      if (title) {
        this.title = title;
      }

      this.openModal();
    });

    Bus.$on('formEditAccountSave', () => {
      this.closeModal();
    });
  },

  methods: {
    openModal () {
      this.$refs['modal-edit-account'].show();

      setTimeout(() => {
        document.querySelector('#form.name').focus();
      }, 500);
    },
    closeModal () {
      this.$refs['modal-edit-account'].hide();
    },
  },
};
</script>
